import { BaseModel } from "@blue-chip/core";
import Project from "./Project";
import File from "./File";

export default class ContractFile extends BaseModel {
  static get belongsTo() {
    return [File, Project];
  }
}
